import request from "@/utils/request";
const api = {
  deployItem: '/api/manage/deployPage/deploy',
}
export function deployItem(parameter){
  return request({url: api.deployItem, method: 'post', data: parameter})
}


